import "./luna.scss";
import "./zq.scss";
import "./hzp.scss";


//开头banner
(() => {
  var header = document.querySelector(".header"),
    btn = header.querySelector(".btn"),
    x = document.querySelector(".x"),
    mask = document.querySelector(".mask"),
    imgList = [
      "x_bg-1.png",
      "x_slogan.png",
      "x_btn.png",
      "x_ad.png"
    ],
    path = "https://n.sinaimg.cn/games/lpl-2019-spring-h5/",
    i = 0;

  imgList.forEach((item, index) => {
    let img = new Image();
    img.onload = function () {
      i++;
      if (i === imgList.length) {
        header.classList.add("header-bg");
        header.classList.add("header-in");
      }
    };
    img.src = path + imgList[index];
  });

  btn.addEventListener("click", function () {
    // mask show
    mask.classList.add("mask-show");
  });
  x.addEventListener("click", function () {
    // mask hide
    mask.classList.remove("mask-show");
  });
})();

const JSONP = (url) => {
  const createSingleId = () => {
    let callbackId;
    do {
      callbackId = `jsonCallBack_${new Date().getTime()}_${Math.ceil(Math.random() * 10000)}`;
    } while (window[callbackId]);
    return callbackId;
  };
  return new Promise((resolve, reject) => {
    let callbackId = createSingleId();
    window[callbackId] = (result) => {
      document.querySelector('head').removeChild(JS);
      resolve(result);
    };
    const JS = document.createElement('script');
    JS.type = 'text/javascript';
    JS.src = `${url}&callback=${callbackId}`;
    document.querySelector('head').appendChild(JS);
  })
};



//赛事进度
let progress_swiper = null;
(function () {
  //swiper
  var total = $('.regular-season-l-top-l .swiper-slide').length;
  var size = 3;
  if (size >= total) {
    $('.regular-season-l-top-r-left,.regular-season-l-top-r-right').css('display', 'none');
  } else {
    progress_swiper = new Swiper('.regular-season-l-top-l', {
      slidesPerView: 'auto',
      slidesPerGroup: 3,
      prevButton: '.regular-season-l-top-r-left',
      nextButton: '.regular-season-l-top-r-right',
    });
  }
  //tab
  $('.regular-season-l-top-l .swiper-slide').click(function () {
    let index = $(this).index();
    $(this).addClass('active').siblings().removeClass('active');
    $('.regular-season-table-container').eq(index).show().siblings().hide();
  });
})();


//赛事进度tab
$('#schedule-progress-tab li').each(function () {
  if ($(this).hasClass('tab-current')) {
    let index = $(this).index();
    if (index === 0) {
      $('.regular-season-container').show().siblings().hide();
    } else {
      $('.playoff-season-container').show().siblings().hide();
    }
  }
});

//赛事进度tab
$('#schedule-progress-tab li').click(function () {
  let index = $(this).index();
  $(this).addClass('tab-current').siblings().removeClass('tab-current');
  if (index === 0) {
    $('.regular-season-container').show().siblings().hide();
  } else {
    $('.playoff-season-container').show().siblings().hide();
  }
});



//赛事进度
new Vue({
  el: ".regular-season-table-cc",
  data() {
    return {
      regular_array: [],
    }
  },
  created() {
    this.requestData();
  },
  methods: {
    requestData() {
      //常规赛
      JSONP('https://interface.sina.cn/games/gpapi/zt/lol_spring_match.d.html?1').then((data) => {
        if (data.status === 1) {
          this.regular_array = data.data;
          this.$nextTick(() => {
            this.setIndexOfWeek();
            //根据第几周来显示第几个
            this.regularInitState();
          });
        }
      });
    },
    regularInitState() {
      [...document.querySelectorAll('.regular-season-l-top-l .swiper-slide')].forEach((tab, index) => {
        if (tab.classList.contains('active')) {
          let containers = document.querySelectorAll('.regular-season-table-container');
          let len = containers.length;
          if (Math.floor(index / 3) === 0) {
            progress_swiper.slideTo(0);
          }
          if (Math.floor(index / 3) === 1) {
            progress_swiper.slideTo(3);
          }
          if (Math.floor(index / 3) === 2) {
            progress_swiper.slideTo(6);
          }
          if (Math.floor(index / 3) === 3) {
            progress_swiper.slideTo(9);
          }
          [...containers].forEach((dom) => {
            dom.style.display = 'none';
          });
          if (index <= len - 1) {
            containers[index].style.display = 'block';
          }
        }
      });
    },
    setIndexOfWeek() {
      let now = new Date();
      let now_date = now.getDate() + '';
      let now_date_res = now_date.length > 1 ? now_date : ('0' + now_date);
      let now_str = `${now.getMonth() + 1}-${now_date_res}`;
      // let now_str = '3-31';
      let index;
      if (now_str < '1-14') {
        index = 0;
      } else if (now_str > '3-31') {
        index = 9;
      } else {
        for (let i = 0; i < this.regular_array.length; i++) {
          let weekData = this.regular_array[i];
          let start = weekData[0].time.split(' ')[0];
          let end = weekData[weekData.length - 1].time.split(' ')[0];
          if (now_str >= start && now_str <= end) {
            index = i;
            break;
          }
        }
      }
      let slides = document.querySelectorAll(".regular-season-l-top-l .swiper-slide");
      [...slides].forEach((dom) => {
        dom.classList.remove('active');
      });
      slides[index].classList.add('active');
    }
  }
});

//赛事进度-积分
new Vue({
  el: ".regular-season-rank-container",
  data() {
    return {
      score_rank: [],
    }
  },
  created() {
    this.requestData();
  },
  methods: {
    requestData() {
      //常规赛
      JSONP('https://interface.sina.cn/games/gpapi/zt/lol_spring_match.d.html?cate=2').then((data) => {
        if (data.status === 1) {
          this.score_rank = data.data.jf;
        }
      });
    },
  }
});

//赛事新闻
let newsCC1 = new Vue({
  el: ".news-cc1",
  data() {
    return {
      news: [],
      page: 1,
    }
  },
  created() {
    this.requestData();
  },
  methods: {
    requestData() {
      let url = `https://interface.sina.cn/games/gpapi/newslist/game_pc_common_search_list.shtml?keywordAnd=lpl,新闻&field=title,URL,cTime,homePic&allstr=6626&pagesize=5&page=${this.page}`;
      //常规赛
      JSONP(url).then((data) => {
        if (data.result.status.code === 1) {
          this.news.push(...data.result.data[0]);
        }
        if (data.result.status.code === 0) {
          document.querySelector('.newsCC1-btn').style.display = 'none';
        }
      });
    },
  },
  watch: {
    page() {
      this.requestData();
    }
  }
});

document.querySelector('.newsCC1-btn').addEventListener('click', () => {
  newsCC1.page++;
});

//赛事视频
let newsCC2 = new Vue({
  el: ".news-cc2",
  data() {
    return {
      news: [],
      page: 1,
    }
  },
  created() {
    this.requestData();
  },
  methods: {
    requestData() {
      let url = `https://interface.sina.cn/games/gpapi/newslist/game_pc_common_search_list.shtml?keywordAnd=lpl,视频&field=title,URL,cTime,homePic&allstr=6626&pagesize=5&page=${this.page}`;
      //常规赛
      JSONP(url).then((data) => {
        if (data.result.status.code === 1) {
          this.news.push(...data.result.data[0]);
        }
        if (data.result.status.code === 0) {
          document.querySelector('.newsCC2-btn').style.display = 'none';
        }
      });
    },
  },
  watch: {
    page() {
      this.requestData();
    }
  }
});

document.querySelector('.newsCC2-btn').addEventListener('click', () => {
  newsCC2.page++;
});

//赛事采访
let newsCC3 = new Vue({
  el: ".news-cc3",
  data() {
    return {
      news: [],
      page: 1,
    }
  },
  created() {
    this.requestData();
  },
  methods: {
    requestData() {
      let url = `https://interface.sina.cn/games/gpapi/newslist/game_pc_common_search_list.shtml?keywordAnd=lpl,采访&field=title,URL,cTime,homePic&allstr=6626&pagesize=5&page=${this.page}`;
      //常规赛
      JSONP(url).then((data) => {
        if (data.result.status.code === 1) {
          this.news.push(...data.result.data[0]);
        }
        if (data.result.status.code === 0) {
          document.querySelector('.newsCC3-btn').style.display = 'none';
        }
      });
    },
  },
  watch: {
    page() {
      this.requestData();
    }
  }
});

document.querySelector('.newsCC3-btn').addEventListener('click', () => {
  newsCC3.page++;
});

(o => {
  /**
   * 页签 - 春季赛季后赛
   */
  // return;
  let playoff_season = new Vue({
    el: ".playoff-season-container",
    data: {
      game1_1: [],
      game1_2: [],
      game3: [],
      afterGame: [],
      finalGame: [],
      cacheData:[]
    },
    computed: {},
    methods: {
      translateTime(str){
        //str "4-4 17：00",
        // 年份为2019
        // 输出 ['4月4日' '星期x' '17:00']
        var _str="",
            mmdd=str.split(" ")[0],
            hhmm = str.split(" ")[1],
            tmp=new Date(
              2019,
              mmdd.split("-")[0]-0-1,
              mmdd.split("-")[1],
              hhmm.split(/：|:/ig)[0],
              hhmm.split(/：|:/ig)[1],
              0
            ),
            json={
              "0":"星期日",
              "1":"星期一",
              "2":"星期二",
              "3":"星期三",
              "4":"星期四",
              "5":"星期五",
              "6":"星期六",
            }
            ;
          _str=[
            `${mmdd.split("-")[0]}月${mmdd.split("-")[1]}日`,
            json[`${tmp.getDay()}`],
            hhmm
          ];
          
          return _str;
      }
    },
    created() {
      let t = this,
          tmp = [],
          d = JSONP('http://interface.sina.cn/games/gpapi/zt/lol_spring_match.d.html?cate=3').then((data) => {
            if (data.status === 1) {
              
              // console.log(111111,data);
              t.cacheData = [].concat.apply([],data.data);
              
              t.cacheData = t.cacheData.map((item,index)=>{
                item.time=t.translateTime(item.time);
                if(index<=1){
                  t.game1_1.push(item);
                }else if(index>1&&index<=3){
                  t.game1_2.push(item);
                }else if(index>3&&index<=5){
                  t.game3.push(item);
                }else if(index==6){
                  t.afterGame.push(item);
                }else{
                  t.finalGame.push(item);
                }
                return item;
              })

              


              this.$nextTick(() => {});
            }
          });
      }
  })


})(undefined)